import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

// TODO: can this be replaced with Array.includes?

/**
 * Returns true if given array contains given item
 *
 * @param arr - The target array
 * @param item - The item to look for
 */
var includes = function includes(arr, item) {
  return arr.indexOf(item) !== -1;
};
/**
 * Type-safe way of looking up an item in an array by index
 * @param arr - The target array
 * @param index - The index to fetch
 */

var lookup = function lookup(arr, index) {
  return arr[index];
};
/**
 * Basic comparator function comparing numeric / ASCII values
 * @param a - Left value
 * @param b - Right value
 */

var defaultSortComparator = function defaultSortComparator(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
/**
 * Native immutable string array push
 * @param arr - The target array
 * @param value - Value to add
 */

var arrayPush = function arrayPush(arr, value) {
  return [].concat(_toConsumableArray(arr), [value]);
};
/**
 * Native immutable string array delete
 * @param arr - The target array
 * @param value - Value to remove
 */

var arrayDelete = function arrayDelete(arr, value) {
  var index = arr.indexOf(value);
  return arr.slice(0, index).concat(arr.slice(index + 1));
};

export { arrayDelete, arrayPush, defaultSortComparator, includes, lookup };
